import { createClient, type SupabaseClient } from '@supabase/supabase-js';

let client: SupabaseClient | null = null;

const IS_LOCAL =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

/**
 * Cookie-based storage scoped to .paperlibrary.org so the session is shared
 * with the Vrass iframe on vrass.paperlibrary.org.
 * Only used in production — localhost uses the default localStorage to avoid
 * the 4KB cookie size limit silently truncating the session JSON.
 */
const cookieStorage = {
  getItem(key: string): string | null {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  },
  setItem(key: string, value: string): void {
    const maxAge = '; max-age=' + 60 * 60 * 24 * 365;
    document.cookie =
      key +
      '=' +
      encodeURIComponent(value) +
      '; path=/; domain=.paperlibrary.org' +
      maxAge +
      '; SameSite=Lax';
  },
  removeItem(key: string): void {
    document.cookie = key + '=; path=/; domain=.paperlibrary.org; max-age=0';
  },
};

export function initSupabaseClient(url: string, anonKey: string): SupabaseClient {
  if (!client) {
    client = createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: IS_LOCAL ? undefined : cookieStorage,
      },
    });
  }
  return client;
}

export function getSupabaseClient(): SupabaseClient | null {
  return client;
}
